import React, {Component} from 'react';
import {client} from '../../Client';
import { Button, Form, Input, Message } from 'semantic-ui-react'
import {convertNullToEmptyString} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import PropTypes from 'prop-types';
class OrganizzazioneForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.idOrganizzazione, // Se undefined siamo in insert, altr in update
            inUpdate: this.props.idOrganizzazione !== undefined,
            fields: this.getEmptyFields(),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null
        };
        this.handleSubmit = this.handleSubmit.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
    }

    componentDidMount() {
        if (this.state.inUpdate)
        {
            this.setState({ _loading: true });
            client.loadOrganizzazione(this.state.id).then(
                (response) => {
                    if (response.ok){
                        response.json().then((item) => {
                            let fields = convertNullToEmptyString(item);
                            this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                                fieldErrorsText: [], inError: false, error: null});
                            this.forceUpdate();
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.context.router.transitionTo("/login")
                    }
                    else
                    {
                        response.json().then((errore) => {
                            let fieldErrorsText = []
                            let fieldErrors = {}
                            this.setState({
                                _loading: false,
                                fieldErrors: fieldErrors,
                                fieldErrorsText: fieldErrorsText,
                                errorTitle: '',
                                error: {title: errore.title, msg: errore.msg},
                                inError: true
                            });
                        });

                    }
            }).catch((error) => {

                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });

            });
        }
    }

    getEmptyFields() {
        return {
            'nome': '',
            'indirizzo' : '',
            'cap' : '',
            'citta' : '',
            'provincia' : '',
            'stato' : '',
            'piva' : '',
            'cfisc' : '',
            'email' : '',
            'pec' : '',
            'web' : '',
            'telefono1' : '',
            'telefono2' : '',
            'fax' : '',
            'note' : '',
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (this.state.fields.nome === undefined || this.state.fields.nome.length === 0)
        {
            fieldErrors["nome"] = true;
            fieldErrorsText.push("Occorre specificare il nome dell'Organizzazione");
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;

        // Validazione form
        if (!this.formIsValid(formData)){
            return;
        }

        // Salvataggio sul server
        delete formData["stato-search"];
        this.setState({_loading: true});
        client.saveOrganizzazione(
            formData,
            this.state.fields.idOrganizzazione
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    let fields = this.state.fields;
                    fields["idOrganizzazione"] = data.idOrganizzazione;
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        successTitle: "Salvataggio organizzazione",
                        successText: "L'organizzazione è stata salvata correttamente",
                        fields: fields });
                    if (this.props.onSaved){

                        this.props.onSaved(data)
                    }
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onInputChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
        }
    }

    onInputChangeUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;

            fields[name] = value.toUpperCase();

            this.setState({ fields });
        }
    }

    render() {

        if (this.state.error != null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess){
            return (
                <div>
                <div className="ui icon positive message">
                    <i className="smile icon"></i>
                    <div className="content">
                        <div className="header">
                            {this.state.successTitle}
                        </div>
                        <p>{this.state.successText}</p>
                    </div>
                </div>
                </div>
            )
        }
        let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Organizzazione</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuova Organizzazione</h3>

        let btnSalva = null;
        if (client.getCurrentUser().isrolerubricaw === true){
            btnSalva = (
                <div className="left aligned eight wide column">
                <Button primary type='submit'><i className="save icon"/> Salva</Button>
            </div>);
        }
        else {
            btnSalva = (
                <div className="left aligned eight wide column">
                    <Button secondary disabled type='submit' ><i className="save icon"/> Non hai i diritti per salvare</Button>
                </div>                
            );
        }


        return (
            <div>
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                {titleMsg}
                <div className="ui attached segment">

                <Form.Group widths="1">
                    <Form.Field label="Nome" width={16} required={true} control={Input} name='nome'  autoComplete="nope" placeholder='Nome organizzazione' maxLength="100"  value={this.state.fields.nome}  onChange={this.onInputChange}/>
                </Form.Group>
                <Form.Group widths='5'>
                    <Form.Input label='Indirizzo' name='indirizzo'  autoComplete="nope" placeholder='Via/Piazza...' width={6} maxLength={255} value={this.state.fields.indirizzo} onChange={this.onInputChange}/>
                    <Form.Input label='Stato' name='stato' placeholder='' autoComplete="nope"  width={1} maxLength={2} value={this.state.fields.stato} onChange={this.onInputChangeUppercase} />
                    <Form.Input label='CAP' name='cap'  autoComplete="nope" placeholder='' width={2} maxLength={10} value={this.state.fields.cap} onChange={this.onInputChange} />
                    <Form.Input label='Città' name='citta'  autoComplete="nope" placeholder='' width={5} maxLength={255} value={this.state.fields.citta} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Provincia' name='provincia'  autoComplete="nope" placeholder='' width={2} maxLength={2} value={this.state.fields.provincia} onChange={this.onInputChangeUppercase}/>
                </Form.Group>
                <Form.Group widths='2'>
                    <Form.Input label='P.IVA' name='piva'  autoComplete="nope" placeholder='' maxLength={11}  value={this.state.fields.piva} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Codice Fiscale' name='cfisc'  autoComplete="nope" placeholder='' maxLength={16}  value={this.state.fields.cfisc} onChange={this.onInputChangeUppercase}/>
                </Form.Group>
                    <Form.Group widths='3'>
                        <Form.Input label='Email' name='email'  autoComplete="nope" width={6} value={this.state.fields.email} error={this.state.fieldErrors["email"]} onChange={this.onInputChange}/>
                        <Form.Input label='PEC'  name='pec' autoComplete="nope" width={4} value={this.state.fields.pec} error={this.state.fieldErrors["pec"]} onChange={this.onInputChange}/>
                        <Form.Input label='Sito web' name='web'  autoComplete="nope" width={10} value={this.state.fields.web} error={this.state.fieldErrors["web"]} onChange={this.onInputChange}/>
                    </Form.Group>
                    <Form.Group widths='4'>
                        <Form.Input label='Tel1'  name='telefono1'  maxLength={30} autoComplete="nope" value={this.state.fields.telefono1} error={this.state.fieldErrors["telefono1"]} onChange={this.onInputChange}/>
                        <Form.Input label='Tel2'  name='telefono2' maxLength={30}  autoComplete="nope" value={this.state.fields.telefono2} error={this.state.fieldErrors["telefono2"]} onChange={this.onInputChange}/>
                        <Form.Input label='Fax'  name='fax'  maxLength={30} autoComplete="nope" value={this.state.fields.fax} error={this.state.fieldErrors["fax"]} onChange={this.onInputChange}/>
                    </Form.Group>
                    <Form.TextArea name='note'  autoComplete="nope" label='Note' placeholder='' rows='3' value={this.state.fields.note} onChange={this.onInputChange}/>

                </div>
                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a onClick={() => (this.props.onCancel())} className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                    </div>
                    {btnSalva}
                </div>

            </Form>
            </div>
        )
    }
}

OrganizzazioneForm.PropTypes = {
    idOrganizzazione: PropTypes.number.isRequired,
    onSaved: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}

OrganizzazioneForm.defaultProps = {
    idOrganizzazione: undefined
};

OrganizzazioneForm.contextTypes = {
    router: PropTypes.object
}

export default OrganizzazioneForm;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/OrganizzazioneForm.js
 **/